import { Chart } from 'primereact/chart';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';

import { useInfoGeofences } from './useInfoGeofences';

const InfoGeofences = () => {

    const {cargaUbicacion, ubicacionSel, setUbicacionSel, ultimaFecha, handleGenerar, cargaTable, 
        chartData, chartOptions, lstUbicacion, dt, lstDatosTable, header,textoFilterTemplate, 
        cantidadFilterTemplate, filtros} = useInfoGeofences()
    

    return (
        <div className="card">
            <h4>Reporte de Dispositivos en Zona</h4>
            <div className="formgrid grid p-fluid mb-3">
                {/* Ubicacion */}
                <div className="field col-12 md:col-5">
                    <label className='font-bold' htmlFor="cboUbicacion">Ubicacion:</label>
                    {cargaUbicacion ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboUbicacion" value={ubicacionSel} onChange={(e) => setUbicacionSel(e.value)} options={lstUbicacion} placeholder="Selecciona una Ubicacion" optionLabel="nombre" filter showClear disabled={cargaTable} />
                    )}
                </div>
                <div className="field col-12 md:col-4">
                    <label className='font-bold'>Ultima Fecha Proceso:</label>
                    <div>
                        <span>{ultimaFecha}</span>
                    </div>
                </div> 
                <div className="field col-12 md:col-3">
                    <Button label="Generar" onClick={handleGenerar} loading={cargaTable} />
                </div>

                {/*  */}
                <div className="field col-12 md:col-12">
                    {cargaTable ? (
                        <div className="flex align-items-center">
                            <div className="flex align-items-end">
                                <Skeleton size="10rem" className="mr-2"></Skeleton>
                                <Skeleton size="11rem" className="mr-2"></Skeleton>
                                <Skeleton size="12rem" className="mr-2"></Skeleton>
                                <Skeleton size="13rem"></Skeleton>
                            </div>
                        </div>
                    ) : (
                        <Chart type="bar" data={chartData} options={chartOptions} />
                    )}
                </div> 
                <div className="field col-12 md:col-12">
                    <DataTable ref={dt} value={lstDatosTable} header={header} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 100, 200]} filters={filtros} filterDisplay="row" emptyMessage="No se encontraron resultados." loading={cargaTable}>
                        <Column header="Booking" field="booking" filter filterPlaceholder="Buscar por Booking" filterElement={(options) => textoFilterTemplate(options, 'booking')} showFilterMenu={false} sortable></Column>
                        <Column header="Contenedor" field="contenedor" filter filterPlaceholder="Buscar por contenedor" filterElement={(options) => textoFilterTemplate(options, 'contenedor')} showFilterMenu={false} sortable></Column>
                        <Column
                            header="Ubicacion Codigo"
                            field="ubicacionCodigo"
                            filter
                            filterPlaceholder="Buscar por UbicacionCodigo"
                            filterElement={(options) => textoFilterTemplate(options, 'ubicacionCodigo')}
                            showFilterMenu={false}
                            sortable
                        ></Column>
                        <Column
                            header="Ubicacion Nombre"
                            field="ubicacionNombre"
                            filter
                            filterPlaceholder="Buscar por Ubicacion Nombre"
                            filterElement={(options) => textoFilterTemplate(options, 'ubicacionNombre')}
                            showFilterMenu={false}
                            sortable
                        ></Column>
                        <Column
                            header="Dispositivo Codigo"
                            field="dispositivoCodigo"
                            filter
                            filterPlaceholder="Buscar por Disp Codigo"
                            filterElement={(options) => textoFilterTemplate(options, 'dispositivoCodigo')}
                            showFilterMenu={false}
                            sortable
                        ></Column>
                        <Column
                            header="Dispositivo Nombre"
                            field="dispositivoNombre"
                            filter
                            filterPlaceholder="Buscar por Ubicacion Nombre"
                            filterElement={(options) => textoFilterTemplate(options, 'dispositivoNombre')}
                            showFilterMenu={false}
                            sortable
                        ></Column>
                        <Column header="Fecha Ingreso" field="fechaInLit" sortable></Column>
                        <Column header="Fecha Última Transmisión" field="fechaSaLit" sortable></Column>
                        <Column header="Estadia" field="estadia" filter filterPlaceholder="Buscar por Ubicacion Nombre" filterElement={cantidadFilterTemplate} showFilterMenu={false} sortable></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default InfoGeofences;
